// extracted by mini-css-extract-plugin
export default {"noResources":"VOzna","noResource":"tr_BQ","noResourcesIcon":"ew6Oo"};